import { Component, Input } from '@angular/core';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';
import { Expert } from '../expert-card/expert-card';
 
@Component({
  selector: 'app-expert-profile-reviews',
  imports: [TranslatePipe],
  templateUrl: './expert-profile-reviews.html',
  styleUrl: './expert-profile-reviews.scss',
})
export class ExpertProfileReviewsComponent {
  @Input() expert: Expert | null = null;
}
